/* eslint-disable @typescript-eslint/no-shadow */
import { Box, Skeleton } from '@mui/material';

export const WorksheetTableSkeleton = () => {
  const columns = 6;
  const rows = 8;

  return (
    <Box width='100%' padding={2}>
      <Box display='flex' borderBottom='1px solid #e0e0e0'>
        <Box width={50} mr={1}>
          <Skeleton variant='rectangular' height={40} />
        </Box>

        {Array.from({ length: columns }).map((_, i) => (
          <Box key={i} flex={1} mr={1}>
            <Skeleton variant='rectangular' height={40} />
          </Box>
        ))}
      </Box>

      {Array.from({ length: rows }).map((_, rowIndex) => (
        <Box key={rowIndex} display='flex' alignItems='center' mt={1}>
          <Box width={50} mr={1}>
            <Skeleton variant='text' width={20} height={30} />
          </Box>

          {Array.from({ length: columns }).map((_, colIndex) => (
            <Box key={colIndex} flex={1} mr={1}>
              <Skeleton variant='rectangular' height={40} />
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
};
